customElements.get("product-form") || customElements.define("product-form", class t extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = !1;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog");

    // === PATCH 1: refrescar disponibilidad en vivo al cargar y al cambiar variante ===
    this.variantInput = this.form.querySelector("[name=id]");
    // Tomar el handle del data-atributo o de la URL
    this.productHandle = this.dataset.handle
      || (window.location.pathname.match(/\/products\/([^\/?]+)/) || [])[1];
    if (this.variantInput && this.productHandle) {
      this.variantInput.addEventListener("change", () => this.refreshLiveAvailability());
      this.refreshLiveAvailability();
    }
  }

  // Consulta en vivo al servidor, ignorando la caché del navegador
  refreshLiveAvailability() {
    fetch(`/products/${this.productHandle}.js`, { cache: "no-store" })
      .then(res => res.json())
      .then(product => {
        const variantId = parseInt(this.variantInput.value, 10);
        const variant = product.variants.find(v => v.id === variantId);
        const isAvailable = variant ? variant.available : product.available;
        this.applyAvailabilityState(isAvailable);
      })
      .catch(err => console.warn("Live availability check failed:", err));
  }

  applyAvailabilityState(isAvailable) {
    const span = this.submitButton.querySelector("span");
    const soldOutMsg = this.submitButton.querySelector(".sold-out-message");
    if (!isAvailable) {
      this.submitButton.setAttribute("aria-disabled", "true");
      span && span.classList.add("hidden");
      soldOutMsg && soldOutMsg.classList.remove("hidden");
    } else {
      this.submitButton.removeAttribute("aria-disabled");
      span && span.classList.remove("hidden");
      soldOutMsg && soldOutMsg.classList.add("hidden");
    }
  }

  async onSubmitHandler(t) {
    if (t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled")) return;

    // === PATCH 2: re-verificar inventario en vivo justo antes de enviar ===
    let liveAvailable = true;
    try {
      const res = await fetch(`/products/${this.productHandle}.js`, { cache: "no-store" });
      const product = await res.json();
      const variantId = parseInt(this.form.querySelector("[name=id]").value, 10);
      const variant = product.variants.find(v => v.id === variantId);
      liveAvailable = variant ? variant.available : product.available;
    } catch (e) {
      console.warn("Live pre-check failed, falling back to cart API:", e);
    }
    if (!liveAvailable) {
      this.handleErrorMessage(window.cartStrings?.soldout || "Este producto está agotado");
      const soldOutMsg = this.submitButton.querySelector(".sold-out-message");
      if (soldOutMsg) {
        this.submitButton.setAttribute("aria-disabled", !0);
        this.submitButton.querySelector("span").classList.add("hidden");
        soldOutMsg.classList.remove("hidden");
      }
      return; // Abortar sin llamar a /cart/add
    }

    // === Flujo original de Dawn (intacto) ===
    this.handleErrorMessage();
    this.submitButton.setAttribute("aria-disabled", !0);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    let e = fetchConfig("javascript");
    e.headers["X-Requested-With"] = "XMLHttpRequest";
    delete e.headers["Content-Type"];
    let r = new FormData(this.form);
    this.cart && (
      r.append("sections", this.cart.getSectionsToRender().map(t => t.id)),
      r.append("sections_url", window.location.pathname),
      this.cart.setActiveElement(document.activeElement)
    );
    e.body = r;
    fetch(`${routes.cart_add_url}`, e)
      .then(t => t.json())
      .then(t => {
        if (t.status) {
          // 422 de Shopify: el servidor dice que está agotado (red de seguridad)
          this.handleErrorMessage(t.description);
          let e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          this.submitButton.setAttribute("aria-disabled", !0);
          this.submitButton.querySelector("span").classList.add("hidden");
          e.classList.remove("hidden");
          this.error = !0;
          return;
        }
        if (!this.cart) { window.location = window.routes.cart_url; return; }
        document.dispatchEvent(new CustomEvent("marababy:cart:item-added", {
          detail: { item: t }
        }));
        this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
        this.error = !1;
        let r = this.closest("quick-add-modal");
        r ? (
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => { this.renderCartContents(t) })
          }, { once: !0 }),
          r.hide(!0)
        ) : this.renderCartContents(t);
      })
      .catch(t => { console.error(t) })
      .finally(() => {
        this.submitButton.classList.remove("loading"),
        this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
        this.error || this.submitButton.removeAttribute("aria-disabled"),
        this.querySelector(".loading-overlay__spinner").classList.add("hidden")
      });
  }

  renderCartContents(response) {
    if (typeof this.cart.renderContentsWithoutOpening === "function") {
      this.cart.renderContentsWithoutOpening(response);
      return;
    }
    this.cart.renderContents(response);
  }

  handleErrorMessage(t = !1) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    this.errorMessageWrapper && (
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
      this.errorMessageWrapper.toggleAttribute("hidden", !t),
      t && (this.errorMessage.textContent = t)
    );
  }
});
